import { QueryClient } from '@tanstack/react-query';

import api from './api';

type queryConfig = {
  staleTime?: number;
};
const createQueryClient = (config: queryConfig = {}): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        queryFn: ({ queryKey }) => api.get(queryKey.join('/')),
        retry: false,
        refetchOnWindowFocus: false,
        ...config,
      },
    },
  });

export default createQueryClient;
